import React from 'react';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { setGlobalCartSelectedEntries } from '../../../store/globalCart/actions';

export const CountCart = ({ position }: { position: string }) => {
  const { totalCartCount } = useSelector((state: IRootState) => state.globalCart);
  const dispatch = useDispatch();

  React.useEffect(() => {
    const selectedEntries = localStorage.getItem('selectedEntries');
    dispatch(setGlobalCartSelectedEntries(JSON.parse(selectedEntries) || []));
  }, []);

  return (
    totalCartCount > 0 && (
      <div
        className={`absolute px-[6px] bg-supportiveRed text-white text-[8px] rounded-full ${position}`}
      >
        {totalCartCount || 0}
      </div>
    )
  );
};

const BtnCart = (props) => {
  return (
    <a
      id="nav-cart"
      href={`${process.env.NEXT_PUBLIC_URL}/cart`}
      className="relative flex items-center h-10 gap-1 px-3 text-reliableBlack"
      {...props}
    >
      <MdOutlineShoppingCart size={20} fill={`#4F4C4D`} />
      <p className="text-xs ml-[2px] font-[600]">Keranjang</p>
      <CountCart position="top-[4px] right-[76px]" />
    </a>
  );
};

export default BtnCart;
